import dashboardDialog from './index.js';

// const SET_DELIVERY_TYPES = (state, fetchedDeliveryTypes) => {
//   state.deliveryTypes = fetchedDeliveryTypes;
// };
const SET_DASHBOARD_TO_ADD = (state, dashboard)=>{
  Object.assign(state.dashboardToAdd, dashboard);
  if(state.dashboardToAdd.configuration.filters==null)state.dashboardToAdd.configuration.filters={};

  _.forEach(dashboard.configuration.filters, (value, propName)=>{
    state.dashboardToAdd.configuration.filters[propName]=value;
  })
}

const SET_FILTERS_ITEM = (state, {propName, value})=>{
  state.dashboardToAdd.configuration.filters[propName]=value;
}

const SET_SALES_REPS = (state, salesReps)=>{
  state.dashboardToAdd.configuration.sales_reps=salesReps;
}

const SET_CUSTOMER_CLASSES = (state, customerClasses) => {
  state.dashboardToAdd.configuration.customerClasses=customerClasses;
}

const SET_INVENTORIES = (state, inventories) => {
  state.dashboardToAdd.configuration.inventories=inventories;
}

const SET_PRODUCT_ID = (state, productId) => {
  state.dashboardToAdd.configuration.productId = productId;
}

const SET_DASHBOARD_TITLE = (state, dashboardTitle)=>{
  state.dashboardToAdd.configuration.title = dashboardTitle;
}

const SET_DASHBOARD_FIELDS = (state, fields)=>{
    state.dashboardToAdd.configuration.fields = fields;
}

const RESET = (state)=>{
  state.dashboardToAdd.id = null;
  state.dashboardToAdd.name = null;
  state.dashboardToAdd.configuration = {};
}

const SET_EDITING_DASHBOARD_ID = (state, dashboardId) => {
  state.editingDashboardId = dashboardId;
}

const CLEAR_EDITING_DASHBOARD_ID = (state) => {
  state.editingDashboardId = null;
}

const ADD_CRITERIA = (state, criteria) =>{
  state.dashboardToAdd.configuration.criterias.push(criteria);
}

const CHANGE_CRITERIA_OPERATOR = (state, {index, operator})=>{
  state.dashboardToAdd.configuration.criterias[index].selectedOperator = operator;
}

const CHANGE_CRITERIA_VALUE = (state, {index, value})=>{
  state.dashboardToAdd.configuration.criterias[index].selectedValue = value;
}

const REMOVE_CRITERIA = (state, index)=>{
  state.dashboardToAdd.configuration.criterias.splice(index,1);
}

export default {
  SET_DASHBOARD_TO_ADD,
  SET_FILTERS_ITEM,
  SET_SALES_REPS,
  SET_DASHBOARD_TITLE,
  RESET,
  ADD_CRITERIA,
  CHANGE_CRITERIA_OPERATOR,
  REMOVE_CRITERIA,
  CHANGE_CRITERIA_VALUE,
  SET_DASHBOARD_FIELDS,
  SET_CUSTOMER_CLASSES,
  SET_PRODUCT_ID,
  SET_INVENTORIES,
  SET_EDITING_DASHBOARD_ID,
  CLEAR_EDITING_DASHBOARD_ID
};
